import { jsx } from 'react/jsx-runtime';
import _get from 'lodash.get';
import { useCallback } from 'react';
import AdyenApplePayButton from '../AdyenApplePayButton/AdyenApplePayButton.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import { useConfig } from '../../../providers/ConfigProvider.js';
import CoreProviders from '../../../providers/CoreProviders.js';
import { useErrorContext } from '../../../providers/ErrorContextProvider.js';
import { PaymentContextProvider, usePaymentContext } from '../../../providers/PaymentContextProvider.js';
import { captureException } from '../../../services/sentryService.js';

function getApplePayErrorType(errorType) {
    return errorType === 'CANCEL' ? 'payment' : 'initialization';
}
const InnerAdyenApplePayButton = (props) => {
    const { t } = useTranslation();
    const { setError } = useErrorContext();
    const { config: { adyen: { clientKey }, }, } = useConfig();
    const onFatalError = useCallback((error) => {
        const errorType = _get(error, 'name', null);
        setError({
            message: t(`checkout.payment.applepay.error.${getApplePayErrorType(errorType)}`),
        });
        if (errorType !== 'CANCEL') {
            captureException({ error });
        }
        props?.onError?.(errorType);
    }, [props?.onError]);
    return jsx(AdyenApplePayButton, { ...props, clientKey: clientKey, onFatalError: onFatalError });
};
/*
 * Wrapper over the true component, because we first need to call the CoreProviders.
 */
const ApplePayModernizeCheckoutButtonWrapper = () => {
    const { appConfig, checkoutState } = usePaymentContext();
    const { applePayButton, currency, sid, customerId, customerType, paymentMethods } = checkoutState ?? {};
    const applePayPaymentMethod = paymentMethods?.find(({ paymentMethodShortName }) => paymentMethodShortName === 'AP');
    const applePayPaymentMethodResponse = applePayPaymentMethod?.details
        ?.adyenPaymentMethodResponse;
    const { applePayOrderAmount, onSubmit, onFatalError: onError } = applePayButton ?? {};
    const { shop, locale, environment, realm } = appConfig ?? {};
    const { domain, siteId } = shop ?? {};
    const handleSubmit = useCallback((applePayToken) => {
        onSubmit?.(applePayToken);
    }, [onSubmit]);
    return (jsx(CoreProviders, { env: environment, shopBundle: realm, locale: locale, domain: domain || '', errorContainerId: "error-container-id", featureName: "applepay", children: jsx(InnerAdyenApplePayButton, { adyenEnvironment: environment === 'prod' ? 'live' : 'test', countryCode: applePayPaymentMethodResponse?.countryCode, amount: Number(applePayOrderAmount), paymentMethodsResponse: applePayPaymentMethodResponse, onSubmit: handleSubmit, onError: onError, siteId: siteId, sid: sid, currency: currency, customerId: customerId?.toString(), customerType: customerType }) }));
};
const ApplePayModernizeCheckoutButton = ({ isDataMocked = false }) => {
    return (jsx(PaymentContextProvider, { isDataMocked: isDataMocked, children: jsx(ApplePayModernizeCheckoutButtonWrapper, {}) }));
};

export { ApplePayModernizeCheckoutButton as default };
//# sourceMappingURL=ApplePayModernizeCheckoutButton.js.map
